const STORE_LABELS = {
  appStore: "App Store",
  googlePlay: "Google Play",
};

const UTM_PARAM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
];

const collectUtmParams = () => {
  const params = new URLSearchParams(window.location.search);
  const utmParams = {};

  UTM_PARAM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) {
      utmParams[key] = value;
    }
  });

  return utmParams;
};

export const trackAppDownloadIntent = ({
  store = "unknown",
  placement = "landing",
  destinationUrl = "",
  eventId,
  intentType = "store_click",
} = {}) => {
  if (typeof window === "undefined") {
    return;
  }

  const storeLabel = STORE_LABELS[store] || store;
  const eventProperties = {
    store,
    placement,
    intent_type: intentType,
    page_url: window.location.href,
    destination_url: destinationUrl,
    content_type: "app",
    content_name: `Nightly ${storeLabel}`,
    ...collectUtmParams(),
  };

  if (eventId) {
    eventProperties.event_id = eventId;
  }

  window.fbq?.("trackCustom", "AppDownloadIntent", eventProperties);
  window.ttq?.track?.("Download", eventProperties);
};

export const trackStoreButtonClick = ({ store, placement, url } = {}) => {
  trackAppDownloadIntent({
    store,
    placement,
    destinationUrl: url,
    intentType: "store_click",
  });
};
